import { useEffect, useState, useMemo } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Pagination from "../../../../components/Pagination";
import api from "../../../../api/api";
import * as bootstrap from "bootstrap";
import BackButton from "../../../../components/BackButton";
import Table from "../../../../components/table";
import usePagination from "../../../../utils/usePagination";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import "../../Common/form.css";
import SearchIcon from "@mui/icons-material/Search";

const VendorMaster = () => {
  const navigate = useNavigate();

  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");

  const [selectedVendor, setSelectedVendor] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const filteredData = useMemo(() => {
    return vendors.filter(
      (vendor) =>
        vendor.name?.toLowerCase().includes(search.toLowerCase()) ||
        vendor.location?.toLowerCase().includes(search.toLowerCase()) ||
        vendor.pan_number?.toLowerCase().includes(search.toLowerCase()) ||
        vendor.gst_number?.toLowerCase().includes(search.toLowerCase()),
    );
  }, [vendors, search]);

  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(filteredData, 10);

  const fetchVendors = async () => {
    try {
      setLoading(true);
      const response = await api.get("/master-data/vendor-master");
      setVendors(response.data.vendors || []);
    } catch (err) {
      setError("Failed to fetch vendors");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVendors();
  }, []);



  // EDIT PAGE
  const handleEditVendor = (vendor) => {
    navigate(`/edit-vendor/${vendor.vendor_id}`);
  };

  // DELETE MODAL
  const handleOpenDeleteModal = (vendor) => {
    setSelectedVendor(vendor);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setSelectedVendor(null);
    setShowDeleteModal(false);
  };

  const handleConfirmDelete = async () => {
    try {
      await api.delete(
        `/master-data/vendor-master/${selectedVendor.vendor_id}`,
      );

      setVendors((prev) =>
        prev.filter((v) => v.vendor_id !== selectedVendor.vendor_id),
      );

      handleCloseDeleteModal();
    } catch (err) {
      console.error("Failed to delete vendor", err);
    }
  };

  const columns = [
    {
      label: "Name",
      accessor: "name",
    },

    

    {
      label: "PAN Number",
      accessor: "pan_number",
    },
    {
      label: "GST Number",
      accessor: "gst_number",
    },
    {
      label: "Segment Type",
      accessor: "segment_type",
    },
    {
      label: "Vendor Kind",
      accessor: "vendor_kind",
    },
    {
      label: "TDS(%)",
      accessor: "tds_percentage",
    },
    {
      label: "Action",
      render: (row) => (
        <>
          <EditIcon
            onClick={() => handleEditVendor(row)}
            style={{
              cursor: "pointer",
              color: "#8393a2",
              marginRight: "10px",
            }}
          />

          <VisibilityIcon
            onClick={() => navigate(`/view-vendor-onboarding/${row.vendor_id}`)}
            style={{
              cursor: "pointer",
              color: "#8393a2",
              marginRight: "10px",
            }}
          />

          <DeleteIcon
            onClick={() => handleOpenDeleteModal(row)}
            style={{
              cursor: "pointer",
              color: "#8393a2",
            }}
          />
        </>
      ),
    },
  ];

  return (
    <>
      <BackButton />

      <style>
        {`
          .search-input {
            padding-left: 45px !important;
            padding-right: 40px !important;
          }

          .search-icon {
            position: absolute;
            left: 12px;
            top: 50%;
            transform: translateY(-50%);
            color: #6c757d;
            pointer-events: none;
            z-index: 2;
          }

          .cancel-icon {
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
            color: #6c757d;
          }
        `}
      </style>

      <div className="mb-3 d-flex align-items-center gap-2">
        <div className="position-relative flex-grow-1">
          <SearchIcon
            className="position-absolute"
            style={{
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#6c757d",
              pointerEvents: "none",
            }}
          />

          <input
            type="text"
            className="form-control search-input"
            placeholder="Search by name..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              goToPage(1);
            }}
          />

          {search && (
            <CancelIcon
              className="position-absolute"
              onClick={() => {
                setSearch("");
                goToPage(1);
              }}
              style={{
                right: "15px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "#6c757d",
              }}
            />
          )}
        </div>

        <button
          type="button"
          className="btn btn-primary"
          onClick={() => navigate("/vendor-onboarding-form")}
        >
          + Add Vendor
        </button>
      </div>

      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No vendors found."
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />

    
      {selectedVendor && showDeleteModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseDeleteModal}
                />
              </div>

              <div className="modal-body">
                <div className="text-center">
                  <p>Are you sure you want to delete this vendor?</p>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={handleCloseDeleteModal}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-danger"
                  onClick={handleConfirmDelete}
                >
                  Confirm Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VendorMaster;
